<template>
  <div id="wrap">
    <Header />
    <Scroll/>
    <div class="hp_productWrap">
      <div class="hp_productMain_tit">
        <h1>회사소개</h1>
      </div>

      <div class="hp_productMain_contentWrap">
        <!-- Sidebar -->
        <div class="hp_productMain_contentSidebar">
          <div class="hp_productMain_contentMenuBox">
            <ul class="hp_productMain_contentMenu">
              <li class="hp_productMain_contentMenu_active">
                <a>회사소개</a>
              </li>
            </ul>
          </div>

          <!-- Hot Keywords -->
          <div class="hp_productMain_contentKeywordBox hp_MobNonePcBlock">
            <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
            <div class="hp_productMain_contentKeyword_tagBox">
              <p v-for="item in statusData.hotKeywordData" :key="item.hot_keyword_ID">
                <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                  #{{ item.hot_keyword_name }}
                </a>
              </p>
            </div>
          </div>
        </div>

        <div class="hp_commuBody">
          <div class="hp_mypageListWrapTit">
            회사소개
          </div>
          <div class="hp_companyWrap">
            <div class="hp_companyTit">(주)행복을주는사람들 소개</div>
            <div class="hp_companyInfo">
              <div class="hp_companyInfoBox">
                <p class="hp_companyInfo_txt01">HAPPY TOUR</p>
                <p class="hp_companyInfo_txt02">
                  안심하고 떠나는 기차여행<br/>
                  <span>(주)행복을주는사람들</span>
                </p>
                <p class="hp_companyInfo_txt03">
                  앞으로도 고객님에게 안전하고 만족스러운 여행 서비스를<br/>
                  제공하도록 노력하겠습니다.
                </p>
              </div>
            </div>

            <div class="hp_companyTit">회사현황</div>
            <div class="hp_companyDetail">
              <ul>
                <li>
                  <div class="hp_companyDetail_tit">
                    <img src="../../../assets/images/icon/icon_company01.png" alt="회사정보">
                    <br/>(주)행복을주는사람들
                  </div>
                  <p>대표이사 : 배성준</p>
                  <p>설립일 : 2012년 04월 04일</p>
                  <p>사업자등록번호 : 106-86-859222</p>
                </li>
                <li>
                  <div class="hp_companyDetail_tit">
                    <img src="../../../assets/images/icon/icon_company02.png" alt="위치정보">
                    <br>소재지
                  </div>
                  <p>(03150) 서울시 종로구 삼봉로 95 대성스카이렉스 408호</p>
                </li>
                <li>
                  <div class="hp_companyDetail_tit">
                    <img src="../../../assets/images/icon/icon_company03.png" alt="대표연락">
                    <br>연락처
                  </div>
                  <p>TEL. 02-3273-3311</p>
                  <p>FAX. 02-3273-4311</p>
                  <p>E-Mail. happy85922@nate.com</p>
                </li>
              </ul>
            </div>

            <div class="hp_companyTit">찾아오시는 길</div>
            <div id="kakao-map" class="hp_companyMap"></div>
            <div class="hp_companyMapInfo">
              <p>지하철로 오시는 방법</p>
              <ul>
                <li><span class="hp_companyMapLine01">1호선</span> <span class="txt_line01">종각역</span> 2번 출구 도보 3분</li>
                <li><span class="hp_companyMapLine03">3호선</span> <span class="txt_line03">안국역</span> 6번 출구 도보 9분</li>
                <li><span class="hp_companyMapLine05">5호선</span> <span class="txt_line05">광화문역</span> 3번 출구 도보 10분</li>
              </ul>
            </div>

            <div class="hp_companyBtn">
              <a href="https://map.kakao.com/?urlX=496150&urlY=1131325&urlLevel=3&itemId=26330352&q=%ED%96%89%EB%B3%B5%EC%9D%84%EC%A3%BC%EB%8A%94%EC%82%AC%EB%9E%8C%EB%93%A4&srcid=26330352&map_type=TYPE_MAP" target="_blank">
                지도 자세히보기
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_hot_keyword_top10
} from '../../ETC/Axios.vue'

export default {
  name: 'CompanyIntroduction',
  components: {
    Header,
    Footer,
    Scroll
  },
  data () {
    return {
      statusData: {
        hotKeywordData: []
      }
    }
  },
  methods: {
    initKakaoMap () {
      const mapContainer = document.getElementById('kakao-map')
      const mapOption = {
        // eslint-disable-next-line no-undef
        center: new kakao.maps.LatLng(37.572366, 126.982547),
        level: 3
      }

      // eslint-disable-next-line no-undef
      const map = new kakao.maps.Map(mapContainer, mapOption)

      // eslint-disable-next-line no-undef
      const markerPosition = new kakao.maps.LatLng(37.572366, 126.982547)

      // eslint-disable-next-line no-undef
      const marker = new kakao.maps.Marker({
        position: markerPosition
      })

      marker.setMap(map)

      // 인포윈도우 내용 - 맵 위치 표시
      const content = `
        <div style="
          background: white;
          border: 1px solid #ccc;
          border-radius: 5px;
          box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
          padding: 10px;
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          line-height: 1.5;
          width: auto;
        ">
          (주)행복을주는사람들
        </div>
        <img 
          style = "
            margin-top:35px;
            width:10px;
            height:10px;
          "
          src="https://t1.daumcdn.net/localimg/localimages/07/2018/pc/map/marker_map01.png"
        >
      `

      // eslint-disable-next-line no-undef
      const customOverlay = new kakao.maps.CustomOverlay({
        position: markerPosition,
        content: content,
        yAnchor: 1
      })

      customOverlay.setMap(map)
    }
  },
  mounted () {
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
    this.initKakaoMap()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/CompanyIntroduction/CompanyIntroduction.vue